// 高级搜索组件slot所需自定义特殊组件
export default {
  install: (Vue, options) => {
    Vue.component("el-dateTime-range", {
      props: {
        name: {
          type: String
        },
        value: {
          type: Array
        }
      },
      data() {
        return {
          priceStart: "",
          priceEnd: ""
        };
      },
      watch: {
        value(newValue) {
          this.priceStart = newValue[0];
          this.priceEnd = newValue[1];
        }
      },
      methods: {
        handleChange() {
          this.$emit("input", [this.priceStart, this.priceEnd]);
        }
      },
      template: `
        <div class="ccui-price-range" >
        <el-date-picker
            @change="handleChange"
            placeholder="请选择开始日期"
            type="datetime"
            style="width:200px!important;padding: 0!important;"
            format="yyyy.MM.dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="priceStart">
        </el-date-picker>
        <span>至</span>
        <el-date-picker
            @change="handleChange"
            placeholder="请选择结束日期"
            type="datetime"
            format="yyyy.MM.dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:200px!important;padding: 0!important;"
            v-model="priceEnd">
        </el-date-picker>
        </div>
      `
    });
  }
};
